<template>

         <div class="peoplemap-part">
            
            <div class="peoplemap-mainmap">
                <div id='map_div' ></div>
            </div>
    
            <div class="peoplemap-menu">
                <a href="javascript:;" class="peoplemap-menu-btn">選單</a>
                <div v-if="seeok"  class="peoplemap-list" >
                    <div class="search-box">
                        <span>請選擇搜尋條件</span>
                        <div class="one-row">
                            <label for="a01">縣市:</label>
                            <select id="a01" v-model="CityCheck" >
                                <option value="" disabled selected hidden>請選擇縣市</option>
                                <option value="" >所有縣市</option>
                                <option  v-for="(item2) in this.searchList" :value="item2.pmId"  :key="item2.pmId">{{item2.pmText}}</option>
                            </select>
                        </div>
                        <div class="one-row search-word">
                            <label for="a05">關鍵字:</label>
                            <input type="text" v-model="keyword" id="a05" class="col-self-100 " placeholder="請輸入關鍵字">
                            <button v-on:click="serchReturn()">搜尋</button>
                        </div>
                    </div>
                    <div class="search-result" >
                        <div class="nothing" v-bind:class="{ open: this.hasdata }">暫無藏品<br>請搜尋其他關鍵字或地區</div>
                        <ul>
                            <li v-for="(item, index) in this.newcollectionList"  :key="item.rowNum">
                                <a v-on:click=" seeok = !seeok , showImage(index) , getCollectID(item.cId) , move(item.lon,item.lat)" :id="item.cId" href="javascript:;" class="one-map-relics-link">
                                    <div class="one-map-relics">
                                        <div class="left">
                                            <div class="map-relics-img">
                                                <img :src="PicturePath(item)" >
                                            </div>
                                        </div>
                                        <div class="right">
                                            <div class="map-relics-title ">
                                                {{item.name}}
                                            </div>
                                            <!-- <div class="map-relics-address">
                                                {{item.address}}
                                            </div> -->
                                        </div>
                                    </div>
                                </a>
                            </li>
    
                        </ul>
                    </div>
                </div>
                <div v-else class="peoplemap-innpage" >
                    <a v-on:click="seeok = !seeok" href="javascript:;" class="back-list-btn" >返回</a>
                    <div class="map-relics-img">
                        <img :src="PicturePath(this.collectiontextList)" >
                    </div>
                    <div class="map-relics-title one-row">
                        {{this.collectiontextList.name}}
                    </div>
                    <div class="map-relics-inf one-row">
                        {{this.collectiontextList.overview}}
                    </div>
    
                    <div class="map-relics-year one-row">
                        <div class="small-title">
                            文物年代：
                        </div>
                        <div class="main-inf">
                            {{this.collectiontextList.ageStart}}-{{this.collectiontextList.ageEnd}}
                        </div>
                    </div>
                    <a :href="LinkPath(this.collectiontextList.cId)" target="_blank" class="btn btn-primary">詳細介紹</a>
                </div>
            </div>

            <div class="backlogo">
                <a href="/" class="home-btn" title="體育運動數位博物館">體育運動數位博物館</a>
            </div>
            
        </div>


</template>

<script>

import $ from 'jquery';
import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster";




export default {
    name: 'App',
    data() {
        return {
            seeok: true,
            markers : [],
            collectionList:"",
            newcollectionList:"",
            searchList:"",
            CityCheck:"",
            map: null,
            hasdata: false,
            keyword:"",

            CollectID:"",
            newfocusPicId:"",
            collectiontextList:"",
    
        };
    },
    methods: {
        move(itemlon,itemlat){
            this.map.panTo({lon: itemlon, lat: itemlat});
        },
        showImage(index) {
            this.selectedIndex = index;
            this.showSelected = true;
        },
        getCollectID(id){
            this.CollectID =  id;
            //alert(this.CollectID);

            this.COLLECTDATAINF( this.CollectID).then(res => {
                    const collectiontextList_res = res.data.data.collectionRoot.collection;
                    this.collectiontextList = collectiontextList_res
                //alert(JSON.stringify(this.collectiontextList.pictureList.items[0].artPicId));
            
            }).catch(err => {
                console.log(err);
            }).finally(() => {
            });
        },
        // 圖片
        PicturePath(id) {
          if( id.focusPicId !== null)
          {

              return `https://iweb.sports.gov.tw/zh-TW/fapi/ArtPic?type=CollectionPic&id=${id.focusPicId}&w=400`;
          }
          if(id.mediaUrlDesc !== null )
          {
              return `//i.ytimg.com/vi/${id.mediaUrlDesc}/maxresdefault.jpg`; 
          }
          else 
          {
               return `https://iweb.sports.gov.tw/images/default.png`; 
              
          }
         
        },
        // 內頁
        LinkPath(cid) {
            return `https://iweb.sports.gov.tw/Collection/CollectionsContent?a=110&cid=${cid}`;
        },

        // 重新刷新搜尋
        serchReturn() {
            
            this.COLLECTDATA( this.CityCheck , this.keyword).then(res => {
                const collectionList_res = res.data.data.collectionRoot.collectionList.items;
                this.collectionList = collectionList_res
                
                //篩選掉0.0經緯
                var newlist = this.collectionList.filter(function(item){
                    return item.lon !== 0; }
                )
                this.newcollectionList = newlist
                

                if( this.newcollectionList.length == 0    )
                {
                    this.hasdata =  true;
                }else{
                    this.hasdata =  false;
                }



                //縣市集中
                if( this.CityCheck == "City1")
                {
                    this.move(	121.5598 , 	25.09108);
                }
                if( this.CityCheck == "City2")
                {
                    this.move(	121.7081, 25.10898);
                }
                if( this.CityCheck == "City3")
                {
                    this.move(	121.6739, 24.91571 );
                }
                if( this.CityCheck == "City4")
                {
                    this.move(	121.7195, 24.69295);
                }
                 /*新竹市 */  
                if( this.CityCheck == "City5")
                {
                    this.move( 120.9647,24.80395 );
                }                 
                /*新竹縣 */                               
                if( this.CityCheck == "City6")
                {
                    this.move(121.1252,	24.70328);
                }                
                /*桃園市*/                               
                if( this.CityCheck == "City7")
                {
                    this.move(121.2168,	24.93759);
                }       
                /*苗栗縣*/                               
                if( this.CityCheck == "City8")
                {
                    this.move(120.9417,24.48927);
                }       
                /*臺中市*/                               
                if( this.CityCheck == "City9")
                {
                    this.move(120.9417,24.23321);
                }       
                /*彰化縣*/                               
                if( this.CityCheck == "City11")
                {
                    this.move(120.4818,23.99297);
                }       
                /*南投縣*/                               
                if( this.CityCheck == "City12")
                {
                    this.move(120.9876,23.83876);
                }       
                /*嘉義市*/                               
                if( this.CityCheck == "City13")
                {
                    this.move(120.4473,23.47545);
                }   
                /*嘉義縣*/                               
                if( this.CityCheck == "City14")
                {
                    this.move(120.574,23.45889);
                }                   
                /*雲林縣*/                               
                if( this.CityCheck == "City15")
                {
                    this.move(120.3897,23.75585);
                }   
                /*臺南市*/                               
                if( this.CityCheck == "City16")
                {
                    this.move(120.2513,23.1417);
                }   
                /*高雄市*/                               
                if( this.CityCheck == "City18")
                {
                    this.move(120.666,23.01087);
                }   
                /*澎湖縣*/                               
                if( this.CityCheck == "City20")
                {
                    this.move(119.6151,23.56548);
                }  
                /*屏東縣*/   
                if( this.CityCheck == "City21")
                {
                    this.move(120.62,22.54951);
                }  
                /*臺東縣*/  
                if( this.CityCheck == "City22")
                {
                    this.move(120.9876,22.98461);
                }   
                /*花蓮縣*/  
                if( this.CityCheck == "City23")
                {
                    this.move(121.3542,23.7569);
                }   
                /*金門縣*/  
                if( this.CityCheck == "City24")
                {
                    this.move(118.3186,24.43679);
                }                   
                /*連江縣*/  
                if( this.CityCheck == "City25")
                {
                    this.move(119.5397,26.19737);
                }   


                //alert(JSON.stringify(this.collectionList));

                /*
                var tiles = L.tileLayer('https://wmts.nlsc.gov.tw/wmts/EMAP/default/GoogleMapsCompatible/{z}/{y}/{x}', {
                    maxZoom: 18,
                    attribution: '資料來源：<a href="https://maps.nlsc.gov.tw/">國土測繪圖資服務雲; <a href="https://egis.moea.gov.tw/">經濟地理圖資中心</a>'
                }),

                latlng = L.latLng(this.collectionList[1].lat, this.collectionList[1].lon);
            


                var map = L.map( 'map_div', {
                    center: latlng,
                    zoom: 8,
                    layers: [tiles]
                });
                */

                //清除上一個搜尋區域
                this.map.removeLayer(this.markers);
            
                this.markers = L.markerClusterGroup({
                    iconCreateFunction: function (cluster) {
                        const number = cluster.getChildCount();
                        return L.divIcon({ 
                            html: number, 
                            className: 'cluster cluster-yellow', 
                            iconSize: L.point(40, 40) ,
                            }
                        
                        );
                    }
                });

                const outthis = this

                this.newcollectionList.forEach(item => {
                    
                    var mapIcon = L.icon({
                        iconUrl: 'https://iweb.sports.gov.tw/images/icon/icon-map.svg',
                        iconSize: [25, 45], // size of the icon
                    });


                    let marker = L.marker([item.lat,item.lon], {title: item.name,} , {icon: mapIcon});
                    //alert(item.mainTitle);
                    // markers.push(marker);
                    
                    var title = item.name;

                    marker.bindPopup(title);
                    marker.setIcon(mapIcon); 
                    outthis.markers.addLayer(marker);
                    this.map.addLayer(outthis.markers);



        
                });
                            
                                
            }).catch(err => {
                console.log(err);
            }).finally(() => {
            });
            this.$router.push("/" + this.CityCheck);
        },


        initMap(){
            // 把初始化後的物件丟到 Vue 裡

            var tiles = L.tileLayer('https://wmts.nlsc.gov.tw/wmts/EMAP/default/GoogleMapsCompatible/{z}/{y}/{x}', {
                maxZoom: 18,
                attribution: '資料來源：<a href="https://maps.nlsc.gov.tw/">國土測繪圖資服務雲; <a href="https://egis.moea.gov.tw/">經濟地理圖資中心</a>'
            }),

            latlng = L.latLng(23.83, 120.83);
        
        
            this.map = L.map( 'map_div', {
                center: latlng,
                zoom: 8,
                layers: [tiles]
            });

        },
        resetMarkers(data){
            // 建立 markers

            data.forEach(item => {
                    
                var mapIcon = L.icon({
                    iconUrl: 'https://iweb.sports.gov.tw/images/icon/icon-map.svg',
                    iconSize: [25, 45], // size of the icon
                });

                var markers = L.markerClusterGroup({
                iconCreateFunction: function (cluster) {
                    const number = cluster.getChildCount();
                    return L.divIcon({ 
                        html: number, 
                        className: 'cluster cluster-yellow', 
                        iconSize: L.point(40, 40) ,
                        }
                    
                    );
                }
                });

  

                let marker = L.marker([item.lat,item.lon], {title: item.name,} , {icon: mapIcon});
                //alert(item.mainTitle);
                // markers.push(marker);
                
                //var title = item.name;

                //this.marker.bindPopup(title);
                //this.marker.setIcon(mapIcon); 
                this.markers.addLayer(marker);
                this.map.addLayer(markers);

    
            });

        },

    },
    mounted() {

            this.$nextTick(function () { 
                
                //預設搜尋
                if( this.$route.params.id == undefined    )
                {
                    this.$route.params.id =  "";
                }

                this.CityCheck = this.$route.params.id

                this.COLLECTDATA( this.$route.params.id , "").then(res => {
                    const collectionList_res = res.data.data.collectionRoot.collectionList.items;
                    this.collectionList = collectionList_res
                    

                   //alert(JSON.stringify(this.collectionList["rowNum"]));
                    //alert(JSON.stringify(this.collectionList));
                    //alert(Object.values(this.collectionList));
                    //var newArr = this.collectionList.filter(i=> i.disabled)
                    //alert(JSON.stringify(newArr));

                    //篩選掉0.0經緯
                    var newlist = this.collectionList.filter(function(item){
                        return item.lon !== 0; }
                    )
                    this.newcollectionList = newlist

                    //alert(JSON.stringify(newlist));


                    if( this.newcollectionList.length == 0    )
                    {
                        this.hasdata =  true;
                    }else{
                        this.hasdata =  false;
                    }


             
                    this.initMap();
    
                    
            
                this.markers = L.markerClusterGroup({
                    iconCreateFunction: function (cluster) {
                        const number = cluster.getChildCount();
                        return L.divIcon({ 
                            html: number, 
                            className: 'cluster cluster-yellow', 
                            iconSize: L.point(40, 40) ,
                            }
                        
                        );
                    }
                });

                const outthis = this

                this.newcollectionList.forEach(item => {
                    
                    var mapIcon = L.icon({
                        iconUrl: 'https://iweb.sports.gov.tw/images/icon/icon-map.svg',
                        iconSize: [25, 45], // size of the icon
                    });


                    let marker = L.marker([item.lat,item.lon], {title: item.name,} , {icon: mapIcon});
                    //alert(item.mainTitle);
                    // markers.push(marker);
                    
                    var title = item.name;

                    marker.bindPopup(title);
                    marker.setIcon(mapIcon); 
                    outthis.markers.addLayer(marker);
                    this.map.addLayer(outthis.markers);

                    /*側邊資料出現 */
                    marker.on("click", function() {
                        outthis.getCollectID(item.cId);
                        outthis.seeok = false
                        //alert(item.address);
                    });


        
                });


                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                });



                
                this.CITYALL().then(res => {
                    const search_res = res.data.data.parameterRoot.parameterList;
                    this.searchList = search_res
                    //alert(JSON.stringify(search_res));
                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                });

 

                $('.peoplemap-menu-btn').on('click', function () {
                    $('.peoplemap-menu').removeClass("open");
                    if($('.peoplemap-menu').hasClass("hide"))
                    {       
                        $('.peoplemap-menu').removeClass("hide");
                        $('.peoplemap-menu').addClass("open");
                    }
                    else
                    {
                        $('.peoplemap-menu').addClass('hide');
                    }
                });

                });
 


            /*
            for (var i = 0; i < Points.length; i++) {
                var a = Points[i];
                var title = a[2];
                var marker = L.marker(new L.LatLng(a[0], a[1]), { title: title });
                marker.bindPopup(title);
                markers.addLayer(marker);
            }
        
            map.addLayer(markers);
            */

        }
}
</script>


<style scoped>

</style>
